import React, { useState } from "react";

const FAQsSection = ({ isDarkMode }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    { question: "What services do you offer?", answer: "We specialize in web design, SEO, and cybersecurity solutions." },
    { question: "How long does a project take?", answer: "Project timelines vary, but most take between 2-6 weeks depending on complexity." },
    { question: "Do you offer ongoing support?", answer: "Yes! We provide maintenance and ongoing support for all our clients." },
    { question: "How can I get a quote?", answer: "Simply click 'Get a Free Quote' or contact us directly." },
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className={`faqs ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openFAQ === index ? "open" : ""}`}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              {faq.question}
              <span className="faq-icon">{openFAQ === index ? "▲" : "▼"}</span>
            </div>
            {openFAQ === index && <p className="faq-answer">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQsSection;
